// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3QPx7","header":"ReportDetails_header__2DIGQ","title":"ReportDetails_title__3dZuw","left":"ReportDetails_left__31kYJ"};